import { render, staticRenderFns } from "./notificationBanner.vue?vue&type=template&id=6e0fdbdf"
import script from "./notificationBanner.ts?vue&type=script&lang=js&external"
export * from "./notificationBanner.ts?vue&type=script&lang=js&external"
import style0 from "./notificationBanner.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports